import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/landing";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-275" data-mp="3mf7qmi3rtqck">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-276" data-mp="3r9lnyq1zu7jv" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-277" data-mp="41rn0thzlh0g">
      <div className="mx-auto max-w-5xl" data-id="element-278" data-mp="91w6mse6yruw">
        <SectionHeading title="What technicians are saying" data-id="element-279" data-mp="937ccxr769on" />
        <div className="mt-4 flex flex-col items-center gap-1" data-id="element-280" data-mp="e0qqlxnwamgl">
          <div className="flex gap-1" aria-hidden="true" data-id="element-281" data-mp="e07g320kr0cl">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-amber-400 text-amber-400" data-id="element-282" data-mp="2avlsbra6l42f" data-mpi={i} />)}
          </div>
          <p className="text-base font-bold text-ink" data-id="element-283" data-mp="1sk9begtakebk">4.9/5 customer rating</p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-284" data-mp="1ntszx29172ru">
          {testimonials.map(t => <figure key={t.name + t.country} className="flex flex-col rounded-3xl bg-brand-50 p-5 sm:p-6" data-id="element-285" data-mp="1iug9k7iybdki">
              <Stars data-id="element-286" data-mp="1eto0pfdzraor" />
              <blockquote className="mt-3 text-[17px] leading-relaxed text-ink" data-id="element-287" data-mp="1eufmjyhsdu1u">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-288" data-mp="2bi3vbpvyka8q">
                <img src={t.image} alt={`${t.name}, verified customer from ${t.country}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" data-id="element-289" data-mp="26k2c94yj8ax9" />
                <div data-id="element-290" data-mp="1xjcis7wquwmp">
                  <p className="font-bold text-ink" data-id="element-291" data-mp="1xlymfwgikrzn">{t.name}</p>
                  <p className="flex items-center gap-1 text-sm text-muted" data-id="element-292" data-mp="r54tz4alb5ys">
                    <BadgeCheckIcon className="h-4 w-4 text-cta-dark" aria-hidden="true" data-id="element-293" data-mp="m3fgzj3t4i82" />
                    Verified customer · {t.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CTAButton className="mt-10" label="I want the same results" data-id="element-294" data-mp="sicukaypoz3w" />
      </div>
    </section>;
}